export const AUTH_RESEND_COOLDOWN_SEC = 60;